import { marked, type Token, type Tokens } from 'marked';
import type { NotificationDraft } from '../../api/notifications';

export function notificationTokens(body: string): Token[] {
  try { return marked.lexer(body, { gfm: true, breaks: true }); }
  catch { return [{ type: 'text', raw: body, text: body }]; }
}

// Explicit allowlist; React renders all other source as text, never injected HTML.
export function notificationLink(href: string): string | undefined {
  try {
    const url = new URL(href);
    if (url.protocol === 'https:' || url.protocol === 'http:' || url.protocol === 'mailto:') return url.href;
  } catch { /* Invalid or relative link: render its label without navigation. */ }
  return undefined;
}
function tokenText(tokens: Token[]): string {
  return tokens.map(token => {
    if (token.type === 'space' || token.type === 'br' || token.type === 'hr') return ' ';
    if (token.type === 'list') return (token as Tokens.List).items.map(item => tokenText(item.tokens)).join(' ');
    if (token.type === 'table') {
      const table = token as Tokens.Table;
      return [table.header, ...table.rows].flat().map(cell => tokenText(cell.tokens)).join(' ');
    }
    if (token.type === 'image') return String(token.text || '');
    return 'tokens' in token && token.tokens ? tokenText(token.tokens) : String(('text' in token && token.text) || token.raw || '');
  }).join(' ');
}
export function notificationExcerpt(notice: Pick<NotificationDraft, 'body' | 'body_format'>): string {
  const text = notice.body_format === 'markdown' ? tokenText(notificationTokens(notice.body)) : notice.body;
  return text.replace(/\s+/g, ' ').trim().slice(0, 160);
}
export function noticeShortTime(value: string | null): string {
  if (!value) return '未发布';
  const date = new Date(value);
  const now = new Date();
  return date.toDateString() === now.toDateString()
    ? date.toLocaleTimeString('zh-CN', { hour: '2-digit', minute: '2-digit', hour12: false })
    : date.toLocaleDateString('zh-CN', { month: '2-digit', day: '2-digit', ...(date.getFullYear() !== now.getFullYear() ? { year: 'numeric' } : {}) });
}
